// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1AVHZ","messages":"Chat_messages__2S5qL","dateDivider":"Chat_dateDivider__2RQyI"};